
import React, { useState } from 'react';
import { MapPin, Search, ExternalLink, ChevronDown, ChevronUp, Users, Heart, Anchor, Info, Globe } from 'lucide-react';

const MEETING_DATA = [
  {
    "type": "Substance",
    "id": "AA",
    "name": "Alcoholics Anonymous",
    "desc": "A fellowship of people sharing experience to solve their common problem with alcohol. The original 12-step program focused on achieving and maintaining long-term sobriety.",
    "finder": "https://www.aa.org/find-aa?location={location}",
    "website": "https://www.aa.org"
  },
  {
    "type": "Substance",
    "id": "NA",
    "name": "Narcotics Anonymous",
    "desc": "A global community for those for whom drugs became a major problem. It offers a recovery process and support network for a drug-free lifestyle.",
    "finder": "https://www.na.org/meetingsearch/text-results.php?zip={location}",
    "website": "https://www.na.org"
  },
  {
    "type": "Substance",
    "id": "CA",
    "name": "Cocaine Anonymous",
    "desc": "A fellowship for people addicted to cocaine and all other mind-altering substances. Members support each other through the 12-step model toward complete abstinence.",
    "finder": "https://ca.org/meetings/?search={location}",
    "website": "https://ca.org"
  },
  {
    "type": "Substance",
    "id": "MA",
    "name": "Marijuana Anonymous",
    "desc": "Support for individuals who have a desire to stop using marijuana and cannabis products. It focuses on the specific psychological and physical challenges of marijuana addiction.",
    "finder": "https://marijuana-anonymous.org/find-a-meeting/?query={location}",
    "website": "https://marijuana-anonymous.org"
  },
  {
    "type": "Substance",
    "id": "CMA",
    "name": "Crystal Meth Anonymous",
    "desc": "A peer support group specifically for those recovering from crystal meth addiction. Members share their common problem and the specific solution they have found.",
    "finder": "https://crystalmeth.org/meetings/?location={location}",
    "website": "https://crystalmeth.org"
  },
  {
    "type": "Substance",
    "id": "HA",
    "name": "Heroin Anonymous",
    "desc": "Concerned solely with the personal recovery and continued sobriety of heroin addicts. It provides a community that understands the specific struggles of opioid dependence.",
    "finder": "https://heroinanonymous.org/find-a-meeting/?location={location}",
    "website": "https://heroinanonymous.org"
  },
  {
    "type": "Substance",
    "id": "PA",
    "name": "Pills Anonymous",
    "desc": "A fellowship for people recovering from addiction to prescription pills and over-the-counter medications. It offers a path to freedom from chemical dependency.",
    "finder": "https://pillsanonymous.org/find-a-meeting/?location={location}",
    "website": "https://pillsanonymous.org"
  },
  {
    "type": "Substance",
    "id": "DRA",
    "name": "Dual Recovery Anonymous",
    "desc": "For people with a dual diagnosis of chemical dependency and emotional or psychiatric illness. It addresses the recovery needs of both disorders simultaneously.",
    "finder": "https://draonline.org/meetings/?location={location}",
    "website": "https://draonline.org"
  },
  {
    "type": "Behavioral",
    "id": "SLAA",
    "name": "Sex and Love Addicts Anonymous",
    "desc": "A program for those recovering from compulsive sexual behavior and romantic obsession. It focuses on developing healthy relationship patterns and emotional sobriety.",
    "finder": "https://slaafws.org/meetings/?search={location}",
    "website": "https://slaafws.org"
  },
  {
    "type": "Behavioral",
    "id": "SAA",
    "name": "Sex Addicts Anonymous",
    "desc": "A fellowship of people sharing their experience to find freedom from addictive sexual behavior. It provides a safe environment to work toward personal sexual sobriety.",
    "finder": "https://saa-recovery.org/meetings/?location={location}",
    "website": "https://saa-recovery.org"
  },
  {
    "type": "Behavioral",
    "id": "SA",
    "name": "Sexaholics Anonymous",
    "desc": "A recovery program for those seeking to stay sexually sober and help others achieve the same. It uses the principles of AA applied to sexual addiction.",
    "finder": "https://www.sa.org/meetings/?location={location}",
    "website": "https://www.sa.org"
  },
  {
    "type": "Behavioral",
    "id": "SCA",
    "name": "Sexual Compulsives Anonymous",
    "desc": "A fellowship for people who want to stop their compulsive sexual behavior. It encourages members to develop their own personal plan of sexual recovery.",
    "finder": "https://sca-recovery.org/meetings/?location={location}",
    "website": "https://sca-recovery.org"
  },
  {
    "type": "Behavioral",
    "id": "GA",
    "name": "Gamblers Anonymous",
    "desc": "For individuals sharing the common problem of compulsive gambling. Members work together to stop gambling and help other gamblers recover.",
    "finder": "https://www.gamblersanonymous.org/ga/locations?state={location}",
    "website": "https://www.gamblersanonymous.org"
  },
  {
    "type": "Behavioral",
    "id": "DA",
    "name": "Debtors Anonymous",
    "desc": "A fellowship for those who want to stop incurring unsecured debt. It provides tools to manage finances and achieve financial solvency and peace of mind.",
    "finder": "https://debtorsanonymous.org/getting-started/find-a-meeting/?location={location}",
    "website": "https://debtorsanonymous.org"
  },
  {
    "type": "Behavioral",
    "id": "UA",
    "name": "Underearners Anonymous",
    "desc": "For those seeking to overcome the inability to acknowledge or express their talents and skills. It helps members earn a prosperous living through 12-step tools.",
    "finder": "https://underearnersanonymous.org/meetings/?location={location}",
    "website": "https://underearnersanonymous.org"
  },
  {
    "type": "Behavioral",
    "id": "OA",
    "name": "Overeaters Anonymous",
    "desc": "A community for those struggling with compulsive eating and food-related behaviors. It addresses physical, emotional, and spiritual well-being regarding food.",
    "finder": "https://oa.org/find-a-meeting/?location={location}",
    "website": "https://oa.org"
  },
  {
    "type": "Behavioral",
    "id": "FAA",
    "name": "Food Addicts in Recovery",
    "desc": "Based on the 12 steps, this program is for those suffering from food addiction, bulimia, and undereating. It promotes a disciplined way of eating and living.",
    "finder": "https://www.foodaddicts.org/find-meeting?location={location}",
    "website": "https://www.foodaddicts.org"
  },
  {
    "type": "Behavioral",
    "id": "WA",
    "name": "Workaholics Anonymous",
    "desc": "A fellowship of people sharing experience to solve their common problem of compulsive overworking. It helps members find balance between work and life.",
    "finder": "https://workaholics-anonymous.org/meetings/?location={location}",
    "website": "https://workaholics-anonymous.org"
  },
  {
    "type": "Behavioral",
    "id": "ITA",
    "name": "Internet & Tech Addiction",
    "desc": "A fellowship for recovering from compulsive internet and technology use. It includes support for addiction to social media, gaming, and digital activities.",
    "finder": "https://internetaddictsanonymous.org/meetings/?location={location}",
    "website": "https://internetaddictsanonymous.org"
  },
  {
    "type": "Family Support",
    "id": "Al-Anon",
    "name": "Al-Anon Family Groups",
    "desc": "Support for friends and families whose lives have been affected by someone else’s drinking. It focuses on the family member's own personal recovery.",
    "finder": "https://al-anon.org/al-anon-meetings/find-an-al-anon-meeting/?address={location}",
    "website": "https://al-anon.org"
  },
  {
    "type": "Family Support",
    "id": "Nar-Anon",
    "name": "Nar-Anon Family Groups",
    "desc": "A fellowship for those affected by a friend or relative’s drug addiction. It offers a 12-step program to help loved ones find peace and coping tools.",
    "finder": "https://www.nar-anon.org/find-a-meeting?location={location}",
    "website": "https://www.nar-anon.org"
  },
  {
    "type": "Family Support",
    "id": "S-Anon",
    "name": "S-Anon International",
    "desc": "For relatives and friends of sex addicts. It provides a safe space to share experiences and find healing from the effects of another's sexual behavior.",
    "finder": "https://sanon.org/find-a-meeting/?location={location}",
    "website": "https://sanon.org"
  },
  {
    "type": "Family Support",
    "id": "COSA",
    "name": "Codependents of Sex Addicts",
    "desc": "A support group for those whose lives have been affected by compulsive sexual behavior in another. It focuses on self-care and relationship recovery.",
    "finder": "https://cosa-recovery.org/find-a-meeting/?location={location}",
    "website": "https://cosa-recovery.org"
  },
  {
    "type": "Family Support",
    "id": "CoDA",
    "name": "Co-Dependents Anonymous",
    "desc": "A fellowship for developing healthy and functional relationships. It helps members overcome patterns of codependency through the 12-step process.",
    "finder": "https://coda.org/find-a-meeting/?query={location}",
    "website": "https://coda.org"
  },
  {
    "type": "Family Support",
    "id": "ACA",
    "name": "Adult Children of Alcoholics",
    "desc": "For adults who grew up in alcoholic or dysfunctional homes. It focuses on reparenting the self and healing the 'inner child' from childhood trauma.",
    "finder": "https://adultchildren.org/find-a-meeting/?location={location}",
    "website": "https://adultchildren.org"
  }
];

interface MeetingFinderProps {
    userLocation: string; // From Profile
}

export const MeetingFinder: React.FC<MeetingFinderProps> = ({ userLocation }) => {
    const [overrideLocation, setOverrideLocation] = useState('');
    const [openCategory, setOpenCategory] = useState<string | null>('Substance');

    const toggleCategory = (cat: string) => {
        setOpenCategory(openCategory === cat ? null : cat);
    }

    const effectiveLocation = overrideLocation.trim() || userLocation || '';

    const handleSearch = (urlTemplate: string) => {
        const query = encodeURIComponent(effectiveLocation);
        const url = urlTemplate.replace('{location}', query);
        window.open(url, '_blank');
    };

    const handleWebsite = (url: string) => {
        window.open(url, '_blank');
    };

    const renderCategory = (category: string, icon: React.ReactNode) => {
        const items = MEETING_DATA.filter(item => item.type === category).sort((a, b) => a.id.localeCompare(b.id));

        return (
            <div className="border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden mb-4">
                <button 
                    onClick={() => toggleCategory(category)}
                    className={`w-full flex items-center justify-between p-4 font-bold transition-colors ${openCategory === category ? 'bg-slate-50 dark:bg-slate-700/50' : 'bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700'}`}
                >
                    <div className="flex items-center gap-3">
                        {icon}
                        <span className="text-slate-800 dark:text-white">{category} Recovery</span>
                    </div>
                    {openCategory === category ? <ChevronUp className="w-5 h-5 text-slate-400" /> : <ChevronDown className="w-5 h-5 text-slate-400" />}
                </button>

                {openCategory === category && (
                    <div className="bg-white dark:bg-slate-800 p-4 grid grid-cols-2 md:grid-cols-4 gap-3 border-t border-slate-200 dark:border-slate-700 animate-in slide-in-from-top-2 duration-200">
                        {items.map(item => (
                            <div key={item.id} className="border border-slate-100 dark:border-slate-700 rounded-lg p-3 hover:border-brand-300 dark:hover:border-brand-600 hover:shadow-sm transition-all flex flex-col justify-between group relative">
                                <div className="mb-3">
                                    <div className="flex justify-between items-start mb-1">
                                        <span className="font-black text-lg text-slate-800 dark:text-white">{item.id}</span>
                                        <div className="relative group/info">
                                            <Info className="w-4 h-4 text-slate-400 cursor-help" />
                                            {/* Custom Tooltip */}
                                            <div className="absolute right-0 top-full mt-2 w-48 bg-slate-800 text-white text-xs p-2 rounded shadow-lg opacity-0 invisible group-hover/info:opacity-100 group-hover/info:visible transition-all z-20">
                                                {item.desc}
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-xs text-slate-500 dark:text-slate-400 leading-tight line-clamp-2 h-8" title={item.name}>{item.name}</p>
                                </div>
                                <div className="space-y-2">
                                    <button 
                                        onClick={() => handleSearch(item.finder)}
                                        className="w-full text-xs font-bold bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 hover:bg-brand-600 hover:text-white dark:hover:bg-brand-600 dark:hover:text-white py-2 rounded flex items-center justify-center gap-1.5 transition-colors"
                                    >
                                        Find Meetings <ExternalLink className="w-3 h-3" />
                                    </button>
                                    <button 
                                        onClick={() => handleWebsite(item.website)}
                                        className="w-full text-[10px] font-medium text-slate-400 hover:text-brand-600 flex items-center justify-center gap-1"
                                    >
                                        <Globe className="w-3 h-3" /> Visit Website
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="space-y-6">
            <div className="bg-blue-600 rounded-2xl p-6 text-white shadow-lg relative overflow-hidden">
                 <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-white opacity-10 rounded-full blur-2xl"></div>
                 <h2 className="text-2xl font-bold flex items-center gap-2 relative z-10">
                     <MapPin className="w-6 h-6" /> The Bridge
                 </h2>
                 <p className="text-blue-100 text-sm mt-1 max-w-sm relative z-10">
                     Connecting you to the fellowship that saves your life. Search across {MEETING_DATA.length} different fellowships.
                 </p>
                 
                 <div className="mt-6 relative z-10">
                    <label className="text-xs font-bold text-blue-200 uppercase tracking-wider mb-1 block">Your Search Location</label>
                    <div className="relative">
                        <input 
                            value={overrideLocation}
                            onChange={(e) => setOverrideLocation(e.target.value)}
                            placeholder={userLocation || "Enter City, Zip, or Country"}
                            className="w-full pl-10 pr-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-blue-200 focus:outline-none focus:bg-white/20 focus:ring-2 focus:ring-white/30 backdrop-blur-sm transition-all"
                        />
                        <Search className="w-4 h-4 text-blue-200 absolute left-3.5 top-3.5" />
                    </div>
                    {!overrideLocation && userLocation && (
                        <p className="text-xs text-blue-200 mt-2 flex items-center gap-1">
                            <Anchor className="w-3 h-3" /> Using default from Profile: <b>{userLocation}</b>
                        </p>
                    )}
                     {!overrideLocation && !userLocation && (
                        <p className="text-xs text-blue-200 mt-2 flex items-center gap-1">
                            <Anchor className="w-3 h-3" /> Please enter a location above.
                        </p>
                    )}
                 </div>
            </div>

            <div>
                {renderCategory('Substance', <Anchor className="w-5 h-5 text-blue-500" />)}
                {renderCategory('Behavioral', <Users className="w-5 h-5 text-emerald-500" />)}
                {renderCategory('Family Support', <Heart className="w-5 h-5 text-rose-500" />)}
            </div>
        </div>
    );
};
